import api from '../util/api';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useGoogleTranslate = text => {
  const { i18n } = useTranslation();

  const language = i18n.language || navigator.language;
  const target = language.split('-')[0];

  const [translated, setTranslated] = useState(false);
  const [translation, setTranslation] = useState(null);
  const [translationError, setTranslationError] = useState(null);
  const translate = () => {
    api
      .translate(text, target)
      .then(result => {
        setTranslated(true);
        setTranslation(result.data.translations[0].translatedText);
      })
      .catch(error => setTranslationError(error.message));
  };

  return {
    translate,
    translated,
    translation,
    original: text,
    translationError,
  };
};

export default useGoogleTranslate;
